module.exports=function(scope){ return `var https = require("https");
var data = JSON.stringify({
  "sessionId": INSERT_SESSION_ID_FROM_zoomSessionResult,
  "enrollmentIdentifier": INSERT_ENROLLMENT_IDENTIFIER_HERE,
  "faceMap": INSERT_FACEMAP_FROM_zoomSessionResult,
  "auditTrailImage": INSERT_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult,
  "lowQualityAuditTrailImage": INSERT_LOW_QUALITY_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult
})

callFaceTecAPI(data, "/api/v2/biometrics/enrollment", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(data, path, callback){
  var options = {
    hostname: "api.zoomauth.com",
    port: 443,
    path: path,
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "X-Device-License-Key": "${scope.appToken}",
        "X-User-Agent": ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
          var obj = JSON.parse(output)
          callback(undefined, obj.data)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.write(data)
  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/nodejs/enrollment-post.js.tpl